import api from '@/helpers/api'

const API_READ = `/api/client/voucher`

export default {
    namespaced: true,
    state: {
        status: '',
        deals: [],
        errMessage: '',
        meta: {
            page: 1,
            limit: 10,
            total: 1
        },
        filter: {},
    },
    mutations: {
        request(state) {
            state.status = "Loading"
        },
        success(state) {
            state.status = "Success"
        },
        error(state, {message}) {
            state.status = "Error",
            state.errMessage = message
        },
        read(state, {deals}) {
            state.deals = [...deals]
        },
        switch_page(state, {meta}) {
            state.meta = {...meta}
        },
        add_filter(state, {filter}) {
            state.filter = {...filter};
        },
        clear_filter(state){
            state.filter = {};
        },
    },
    actions: {
        read({commit, state}) {
            commit('request');

            const {meta} = state
            const {filter} = state
            
            return new Promise((resolve, reject) => {
                api.request('get', API_READ, {meta, filter})
                    .then((result) => {
                        commit('success');
                        commit('read', { deals: result.data.data.voucher });
                        commit('switch_page', { meta: {...result.data.meta} });

                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        }
    },
    getters: {
        deals: () =>(state) => state.deals,
    }
}